<ng-container *ngIf="contactForm" [formGroup]="contactForm">
  <div class="contact-form-row" *ngIf="!!withoutPhoneInfo">
    <div class="contact-form-inputs">
      <app-form-text-input
        [form]="contactForm"
        [formControlSelector]="phoneControl"
        [id]="phoneControl"
        [maxLength]="maxPhone"
        [formInputType]="onlyNumberInput"
        [isSubmitted]="isSubmitted"
        [placeholder]="'BOOKING_MODULE.CONTACT_INFO.PHONE' | transloco">
      </app-form-text-input>
    </div>
  </div>
  <div class="contact-form-row">
    <div class="contact-form-inputs">
      <app-form-text-input
        [form]="contactForm"
        [formControlSelector]="emailControl"
        [id]="emailControl"
        [maxLength]="maxEmail"
        [formInputType]="emailInputType"
        [isSubmitted]="isSubmitted"
        [placeholder]="'BOOKING_MODULE.CONTACT_INFO.EMAIL' | transloco">
      </app-form-text-input>
    </div>
  </div>
  <div class="button-form-row">
    <div class="button-container">
      <app-ds-button
        [labels]="{ ButtonLabel: 'BOOKING_MODULE.CONTACT_INFO.SAVE' | transloco }"
        (clickEvent)="save()">
      </app-ds-button>
    </div>
  </div>
</ng-container>
